export const modalAnimation = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const signInAnimationStyle = {
  config: { duration: 900 },
  to: { opacity: 1 },
  from: { opacity: 0 },
};
